module.exports = __webpack_public_path__ + "media/07.e73c8c73.mp3";